import React from 'react';
export function PainSection() {
  const pains = ['Te prometés no gritar… pero a veces gritás.', 'Querés poner límites con amor… pero dudás si lo estás haciendo bien.', 'Intentás ser paciente… pero terminás agotado/a.'];
  return <section className="w-full bg-[#FDF8F3] py-16 px-4" data-id="element-167">
      <div className="max-w-3xl mx-auto" data-id="element-168">
        <h2 className="text-2xl sm:text-3xl font-bold text-[#5C4033] mb-8 text-center" data-id="element-169">
          ¿Y si el problema no sos vos…
          <br data-id="element-170" />
          <span className="text-[#8B9E7E]" data-id="element-171">
            sino que nadie te enseñó cómo criar con herramientas claras?
          </span>
        </h2>

        <div className="bg-[#F5EDE4] rounded-2xl p-8 sm:p-10 shadow-sm" data-id="element-172">
          <p className="text-xl sm:text-2xl font-semibold text-[#5C4033] mb-4 text-center" data-id="element-173">
            Criar no debería sentirse como estar fallando todos los días.
          </p>
          <p className="text-lg text-[#8B7355] mb-8 text-center" data-id="element-174">
            Y sin embargo…
          </p>

          <ul className="space-y-4 mb-8" data-id="element-175">
            {pains.map((pain, index) => <li key={index} className="flex items-start gap-3" data-id="element-176">
                <span className="flex-shrink-0 w-2 h-2 bg-[#C4645A] rounded-full mt-2.5" data-id="element-177" />
                <span className="text-[#8B7355] text-lg" data-id="element-178">{pain}</span>
              </li>)}
          </ul>

          <div className="space-y-3 text-[#8B7355] text-lg leading-relaxed" data-id="element-179">
            <p data-id="element-180">No porque no ames a tu hijo. No porque no lo intentes.</p>
            <p className="font-semibold text-[#5C4033]" data-id="element-181">
              Sino porque criar sin estructura clara cansa.
            </p>
            <p className="font-bold text-[#5C4033] text-xl" data-id="element-182">Y mucho.</p>
          </div>
        </div>
      </div>
    </section>;
}